// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3V2DE","inputWrap":"CustomTip_inputWrap__3b0yV"};